// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewing-as-banner {
  background-color: #ff9800;
  color: #fff;
  padding: 12px 20px;
  text-align: center;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  position: relative;
}

.viewing-as-banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.viewing-as-banner-icon {
  font-size: 18px;
}

.viewing-as-banner-text {
  font-size: 14px;
}

.viewing-as-banner-text strong {
  font-weight: 600;
}








`, "",{"version":3,"sources":["webpack://./src/ViewingAsBanner.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".viewing-as-banner {\n  background-color: #ff9800;\n  color: #fff;\n  padding: 12px 20px;\n  text-align: center;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  position: relative;\n}\n\n.viewing-as-banner-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.viewing-as-banner-icon {\n  font-size: 18px;\n}\n\n.viewing-as-banner-text {\n  font-size: 14px;\n}\n\n.viewing-as-banner-text strong {\n  font-weight: 600;\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
